// 📁 src/redux/slices/MarketingactivityOptionsSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

// ✅ Types
interface MarketingactivityOption {
  label: string;
  value: string;
}

interface FetchMarketingactivityParams {
  page?: number;
  limit?: number;
  searchTerm?: string | null | any;
  MARKETING_ACTIVITY?: any;
  TITLE?: any;
  FILE_NAME?: any;
}

interface MarketingactivityOptionsState {
  MarketingactivityOption: any;
  loading: boolean;
  error: string | null;
  hasMore: boolean;
  currentPage: number;
  limit: number;
  LoadingofMarketing:boolean
  LoadingofTitleASAP:boolean
  LoadingofFileASAP:boolean
}

// ✅ Initial State
const initialState: MarketingactivityOptionsState = {
  MarketingactivityOption: [],
  loading: false,
  error: null,
  hasMore: true,
  currentPage: 1,
  limit: 10,
  LoadingofMarketing:false,
    LoadingofTitleASAP:false,
  LoadingofFileASAP:false
};

export const FetchMarketingactivity = createAsyncThunk(
  "dateOptions/fetch",
  async (params: FetchMarketingactivityParams = {}, { rejectWithValue }) => {
    try {
      const queryParams: string[] = [];

      if (params.page !== undefined) queryParams.push(`page=${params.page}`);
      if (params.limit !== undefined) queryParams.push(`limit=${params.limit}`);
      if (params.searchTerm !== undefined)
        queryParams.push(`searchTerm=${params.searchTerm}`);
      // if (params.DATE?.length) queryParams.push(`DATE=${params.DATE}`);
      if (Array.isArray(params.MARKETING_ACTIVITY)) {
        params.MARKETING_ACTIVITY.forEach((date) => {
          queryParams.push(`MARKETING_ACTIVITY=${encodeURIComponent(date)}`);
        });
      }
      if (Array.isArray(params.TITLE)) {
        params.TITLE.forEach((title) => {
          queryParams.push(`TITLE=${encodeURIComponent(title)}`);
        });
      }
      if (Array.isArray(params.FILE_NAME)) {
        params.FILE_NAME.forEach((file) => {
          queryParams.push(`FILE_NAME=${encodeURIComponent(file)}`);
        });
      }
      // if (params.TITLE?.length) queryParams.push(`TITLE=${params.TITLE}`);
      // if (params.FILE_NAME?.length)
      //   queryParams.push(`FILE_NAME=${params.FILE_NAME}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await axios.get(
        `${API.GetMarketingActivity}${queryString}`
      );

      return {
        data: response.data,
        page: params.page ?? 1,
      };
    } catch (err: any) {
      if (err.response?.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

const MarketingactivityOptionsSlice = createSlice({
  name: "MarketingactivityOptions",
  initialState,
  reducers: {
    clearMarketingactivityOptions: (state) => {
      state.MarketingactivityOption = [];
      state.currentPage = 1;
      state.hasMore = true;
      state.loading = false;
      state.error = null;
    },
    setLoadingofMarketing:(state,action)=>{
      state.LoadingofMarketing=action.payload
    },
    setLoadingofTitleASAP:(state,action)=>{
      state.LoadingofTitleASAP=action.payload
    },
    setLoadingofFileASAP:(state,action)=>{
      state.LoadingofFileASAP=action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchMarketingactivity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchMarketingactivity.fulfilled, (state, action) => {
        const { data, page } = action.payload;

        const formatted = (data.marketing_activity_options || []).map(
          (item: string) => ({
            label: item,
            value: item,
          })
        );
        console.log(formatted, "MARKETING_ACTIVITY");
        if (page === 1) {
          state.MarketingactivityOption = formatted;
        } else {
          state.MarketingactivityOption = [
            ...state.MarketingactivityOption,
            ...formatted,
          ];
        }

        state.currentPage = page;
        state.hasMore = data.hasMore;
        state.loading = false;
      })
      .addCase(FetchMarketingactivity.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) ?? "Fetch failed";
      });
  },
});

// ✅ Export Actions and Reducer
export const { clearMarketingactivityOptions ,setLoadingofMarketing,setLoadingofFileASAP,setLoadingofTitleASAP} =
  MarketingactivityOptionsSlice.actions;
export default MarketingactivityOptionsSlice.reducer;
